// extracted by mini-css-extract-plugin
export default {"loginSignUp":"LoginSignUp_loginSignUp__epAup","login":"LoginSignUp_login__jJoqb","signup":"LoginSignUp_signup__-5534","icon":"LoginSignUp_icon__R5GZX"};